import styled from 'styled-components'

export const WorkInfoAkaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
